import { fromJS } from 'immutable';
import { NODE_GET_LOADED } from '../../../actions/Entity/Node';
var initialState = fromJS({});
export default function node() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case NODE_GET_LOADED:
      {
        return state.set(action.node_id, fromJS(action.data));
      }
    default:
      return state;
  }
}